export default {
  AppMessageHighlightVisualRadio: 'AppMessageSmall',
}
